import {Jumbotron } from "react-bootstrap";
const Admin = () => {
    return ( 
        <Jumbotron>
            <h1>Admin</h1>
        </Jumbotron>
     );
}
 
export default Admin;